class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);

/* 16 Oct 2026 (Claude): "Chat with us" links for the Shopify Inbox chat.
   - Any link or button with data-sfr-chat (or href="#chat") opens the chat. If the
     chat can't be opened, the link carries on to its href (the contact page).
   - Adds "Chat with us" to the footer Info menu, the mobile menu (under Contact),
     the end of the FAQ sections and the FAQ & Info page, and the top of the contact page.
   The chat button itself is styled in assets/footer.css (orange, hidden on phones).
   The chat is the <shopify-chat> element; its button is ::part(activator). */
(function () {
  if (window.sfrOpenChat) return;

  /* Before the chat has been opened the button sits in <shopify-chat>'s shadow root;
     after that it sits inside <shopify-agent-runtime> in there. Look in both. */
  function runtimeEl() {
    var host = document.querySelector("shopify-chat");
    var sr = host && host.shadowRoot;
    return sr ? sr.querySelector("shopify-agent-runtime") : null;
  }

  function chatButton() {
    var rt = runtimeEl();
    var host = document.querySelector("shopify-chat");
    var root = (rt && rt.shadowRoot) || (host && host.shadowRoot);
    return root ? root.querySelector('button[part~="activator"]') || root.querySelector("button.activator") : null;
  }

  window.sfrOpenChat = function () {
    var b = chatButton();
    if (b) {
      if (b.getAttribute("aria-expanded") !== "true") b.click();
      return true;
    }
    var rt = runtimeEl();
    if (rt && typeof rt.show === "function") {
      try { rt.show(); return true; } catch (x) {}
    }
    return false;
  };

  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-sfr-chat], a[href="#chat"]');
    if (!t) return;
    if (window.sfrOpenChat()) {
      e.preventDefault();
    } else if (t.getAttribute("href") === "#chat") {
      e.preventDefault();
      window.location.href = "/pages/contact";
    }
  });

  function chatLink(cls, text) {
    var a = document.createElement("a");
    a.href = "/pages/contact";
    a.className = cls;
    a.setAttribute("data-sfr-chat", "");
    a.textContent = text;
    return a;
  }

  function addFooter() {
    var blocks = document.querySelectorAll(".m-footer--block-menu");
    for (var i = 0; i < blocks.length; i++) {
      var title = blocks[i].querySelector(".m-footer--block-title");
      if (!title || !/info/i.test(title.textContent)) continue;
      var ul = blocks[i].querySelector("ul");
      if (!ul || ul.querySelector("[data-sfr-chat]")) return;
      var li = document.createElement("li");
      li.className = "m-link-lists--item m:block";
      li.appendChild(chatLink("m-link sfr-chat-link", "Chat with us"));
      ul.appendChild(li);
      return;
    }
  }

  function addMenu() {
    var ul = document.querySelector(".m-menu-drawer__navigation.m-menu-mobile");
    if (!ul || ul.querySelector("[data-sfr-chat]")) return;
    var li = document.createElement("li");
    li.className = "m-menu-mobile__item m-menu-mobile__item--no-submenu";
    li.appendChild(chatLink("m-menu-mobile__link sfr-chat-link", "Chat with us"));
    var contact = ul.querySelector('li[data-url="/pages/contact"]');
    if (contact && contact.nextSibling) ul.insertBefore(li, contact.nextSibling);
    else ul.appendChild(li);
  }

  function addFaq() {
    var boxes = Array.prototype.slice.call(document.querySelectorAll("section.faq-wrap .faq-container"));
    /* The FAQ & Info page is one long page of text: add the line at the end of it. */
    if (/^\/pages\/faq\/?$/.test(window.location.pathname)) {
      var page = document.querySelector("#MainContent .m-page-content");
      if (page) boxes.push(page);
    }
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].querySelector(".sfr-chat-faq")) continue;
      var p = document.createElement("p");
      p.className = "sfr-chat-faq";
      p.appendChild(document.createTextNode("Didn’t find your answer? "));
      p.appendChild(chatLink("sfr-chat-link", "Chat with us"));
      boxes[i].appendChild(p);
    }
  }

  function addContact() {
    if (!/^\/pages\/contact\/?$/.test(window.location.pathname)) return;
    var form = document.querySelector('form[action*="/contact"]');
    if (!form || document.querySelector(".sfr-chat-contact")) return;
    var box = document.createElement("div");
    box.className = "sfr-chat-contact";
    box.innerHTML = '<p class="sfr-chat-contact__t">Quickest answer? Chat with us now.</p>';
    box.appendChild(chatLink("sfr-chat-contact__btn", "Chat with us"));
    form.parentNode.insertBefore(box, form);
  }

  function run() {
    try { addFooter(); } catch (x) {}
    try { addMenu(); } catch (x) {}
    try { addFaq(); } catch (x) {}
    try { addContact(); } catch (x) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
